import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { ApiCallService } from 'src/app/core/services/api-call-service';
import { SnackbarCollection } from 'src/app/core/services/snackbar.service';
import { SuccessDialogComponent } from 'src/app/shared/components/dialog-box';
import { ExportEventService } from '../../service/export-event.service';

@Component({
  selector: 'app-coupon-pool-export',
  templateUrl: './coupon-pool-export.component.html',
  styleUrls: ['./coupon-pool-export.component.css','../badge-create/badge-create.component.css']
})
export class CouponPoolExportComponent implements OnInit {

  constructor( 
    private dialogRefer: MatDialogRef<CouponPoolExportComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private apiCall: ApiCallService,
    private _snackBar: SnackbarCollection,
    private dialog: MatDialog,
    private exportEventService: ExportEventService) { }

  ngOnInit(): void {
    this.selectedCouponPoolId = this.data.couponPoolList[0].id;
  }

  closedialog(action) {
    if(action == 'refreshCouponPoolList') {
      this.dialogRefer.close({action:'refreshCouponPoolList'});
    } else {
      this.dialogRefer.close(false);
    }
  }

  selectedCouponPoolId = null;
  selectedFileType = 'EXCEL';
  exportCouponPool() {
    let isCsv = this.selectedFileType == 'CSV';
    const dialogRef = this.dialog.open(SuccessDialogComponent, {
      panelClass: "no-padding-dialog-popup",
      width: "30%",
      data: {
        message: "Your file is being export, It will be downloaded shortly.",
        buttonText: "Ok",
      },
    });
    dialogRef.afterClosed().subscribe((result) => {
      if (result) {
        this.closedialog('refreshCouponPoolList');
      }
    });
    this.apiCall.exportCouponPool(this.selectedCouponPoolId,isCsv).subscribe(
      (response) => {
        const blob = new Blob([response], { type: 'application/octet-stream' }); // Change type based on your file
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = url;
        a.download = 'exported_file.zip'; // Change the filename as needed
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
        window.URL.revokeObjectURL(url);
        this.exportEventService.notifyExportCompleted(); // Notify that the export is completed and refesh the list component
      },
      (error) => {
        this._snackBar.openSnackBar(error.error, 4000);
      }
    );
  }
}
